var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 45.5,
    viewBox: "0 0 1920 45.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "wave",
    d: "M1920,196.128l-64-4.542c-64-4.542-192-13.625-320-21.2-128-7.466-256-13.711-384-9.084-128,4.457-256,19.785-384,24.242-128,4.627-256-1.618-384,0-128,1.5-256,10.588-320,15.13L0,205.212H1920Z",
    transform: "translate(0 -159.712)",
    fill: "#061136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave3);
export default __webpack_public_path__ + "static/media/wave3.a529fa29af1a36e006baabfe8192f3c7.svg";
export { ForwardRef as ReactComponent };